import { TQueryRewardUser } from '@src/modules/reward-user'

import { request } from './config'

export const getLisRewardUser = (params: TQueryRewardUser, token: string) =>
  request({ url: 'reward-user', method: 'GET', params }, { token })
export const removeRewardUserById = (id: string) => request({ url: `reward-user/${id}`, method: 'DELETE' })
export const removeRewardUserByIds = (data: { ids: string[] }) =>
  request({ url: 'reward-user/delete-many', method: 'POST', data })
export const getRewardUserById = (id: string, token: string) =>
  request({ url: `reward/${id}`, method: 'GET' }, { token })
export const exportListRewardUser = (params: TQueryRewardUser, token: string) =>
  request(
    {
      url: 'reward-user/export-xlsx',
      method: 'GET',
      params,
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    },
    { token },
  )
